export default __webpack_public_path__ + "static/media/colors_fonts-01.2a6ff05c.jpg";